import { render, staticRenderFns } from "./DocAccordion.vue?vue&type=template&id=35286deb&scoped=true&"
import script from "./DocAccordion.vue?vue&type=script&lang=js&"
export * from "./DocAccordion.vue?vue&type=script&lang=js&"
import style0 from "./DocAccordion.vue?vue&type=style&index=0&id=35286deb&lang=scss&scoped=true&"
import style1 from "./DocAccordion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35286deb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35286deb')) {
      api.createRecord('35286deb', component.options)
    } else {
      api.reload('35286deb', component.options)
    }
    module.hot.accept("./DocAccordion.vue?vue&type=template&id=35286deb&scoped=true&", function () {
      api.rerender('35286deb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/documents/DocAccordion.vue"
export default component.exports